import React from "react";


const styles = {
    p:{border:'1px solid gray', width:'380px', backgroundColor:'#ddd'},
    div:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#ddd'},
    divLogo:{textAlign:'center', width:'380px', margin:'10px 0 0 0', backgroundColor:'#fff'},
    divWhite:{textAlign:'center', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
    divWhiteLeft:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
    divWhiteLeftNoBorder:{width:'380px', padding:'10px 20px', margin:'10px 0',backgroundColor:'#fff'},
    li:{padding:'6px 0'},
}


export const setEmailBodyGeneral = ({ formValues, datosRegistro }) => {

    console.log(formValues, datosRegistro);

    const docAnexo = (formValues.tipoRegistroDocURL !== '') ? 
            <a href={ formValues.tipoRegistroDocURL }>
                <strong>Consultar documento probatorio</strong>
            </a>
        : '';


    // - Data adicional, para enlaces
    const detailsLink = 
    "<ul>" +
        `Consulte los detalles de su registro en <a href=${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${ formValues.registroReferencia }>este enlace</a>.` +
    "</ul>";

    return (
        <>
            <div style={styles.divLogo}>
                <img src={ datosRegistro.urlLogo } alt="logo" width={ 100 } />
            </div>
            <div style={styles.divWhite}>
                <h2><i>{ datosRegistro.tituloEvento }</i></h2>
            </div>
            <div style={styles.divWhite}>
                <h3>¡Registro inicial completado con éxito!</h3>
            </div>
            <div style={styles.divWhiteLeft}>
                <p>
                    Nombre completo:<br /> 
                    <strong>{ formValues.partNombres } { formValues.partApellidoPaterno } { formValues.partApellidoMaterno }</strong> <br /><br />
                    Correo: <br />
                    <strong>{ formValues.partCorreo }</strong> <br /><br />
                    Procedencia: <br />
                    <strong>{ formValues.partEstado }, { formValues.partPais }</strong> 
                </p>
                <p>
                    Tipo de inscripción: <br />
                    <strong>{ formValues.tipoRegistro }</strong> { docAnexo }<br /><br />
                    Numero de referencia asignado por el sistema: <br />
                    <strong>{ formValues.registroReferencia }</strong>
                </p>

                <div dangerouslySetInnerHTML={{ __html: detailsLink }} />

            </div>
        </>
    );
};
